module.exports = __webpack_public_path__ + "img/Mask Group up.d5d22a3d.svg";